var _defs, _path, _polygon;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInternet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "SvgjsSvg1011",
    width: 288,
    height: 288,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "SvgjsDefs1012"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SvgjsG1013"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 288,
    height: 288,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 288,
    height: 288,
    enableBackground: "new 0 0 490 490",
    viewBox: "0 0 490 490",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#03507d",
    d: "M15.312,381.542h214.375v54.865H126.328v30.625h237.344v-30.625H260.313v-54.865h214.375 c8.422,0,15.313-6.891,15.313-15.312V38.281c0-8.422-6.891-15.312-15.313-15.312H15.312C6.891,22.969,0,29.859,0,38.281v327.948 C0,374.651,6.891,381.542,15.312,381.542z M30.625,53.594h428.75v297.323H30.625V53.594z",
    className: "color000 svgShape colorac11e9"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#03507d",
    points: "379.765 219.612 364.499 158.76 343.582 158.76 327.641 218.617 314.503 158.76 302.054 158.76 296.496 158.76 284.338 158.76 270.955 219.612 255.688 158.76 234.771 158.76 218.846 218.617 205.708 158.76 193.244 158.76 187.701 158.76 175.527 158.76 162.159 219.612 146.893 158.76 125.976 158.76 110.036 218.617 96.897 158.76 78.89 158.76 99.7 245.888 118.779 245.888 136.067 180.749 153.431 245.888 172.082 245.888 190.441 170.275 208.495 245.888 227.574 245.888 244.877 180.749 262.227 245.888 280.892 245.888 299.252 170.275 317.306 245.888 336.385 245.888 353.673 180.749 371.022 245.888 389.688 245.888 410.85 158.76 393.148 158.76",
    className: "color000 svgShape colorac11e9"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInternet);
export default __webpack_public_path__ + "static/media/internet.2b23911cccaa10df09685a8240289e06.svg";
export { ForwardRef as ReactComponent };